import { Drawer } from 'shared/antd'
import { FAQ } from 'shared/common/FAQ/components/FAQ/Desktop'
import { FAQCategory } from 'shared/common/FAQ/model/types'
import { SupportItem } from 'shared/common/Header/ui/SupportItem/Mobile'
import { clsx } from 'shared/libs/style-merge'

import { Fragment } from 'react'

import { Divider } from 'shared/ui/divider'

import styles from './SupportDrawer.module.scss'

interface SupportDrawerProps {
  onClose: () => void
  isOpen: boolean
}

const supportItems = [
  {
    label: 'Поддержка в Telegram',
    link: 'https://t.me/marketmbank',
    logo: '/static/svg/telegram.svg',
  },
  {
    label: 'Поддержка в WhatsApp',
    link: 'https://wa.me/996224143333',
    logo: '/static/svg/whatsapp.svg',
  },
  {
    label: 'Позвонить в поддержку',
    link: 'tel:+996224143333',
    logo: '/static/png/iconphone.png',
  },
]

export function SupportDrawer({ isOpen, onClose }: SupportDrawerProps) {
  return (
    <Drawer type="secondary" open={isOpen} onClose={onClose}>
      <div className={styles.wrapper}>
        <div className={styles.block}>
          <h4 className={styles.title}>Служба поддержки</h4>
          <p className={styles.subtitle}>Работает ежедневно с 09:00 до 20:00</p>
          <div className={styles.supportWrapper}>
            <span className={styles.label}>Способы связи</span>
            {supportItems.map((item, index, arr) => (
              <Fragment key={item.label}>
                <SupportItem {...item} />
                {index !== arr.length - 1 && (
                  <Divider type="horizontal" margin="medium" />
                )}
              </Fragment>
            ))}
          </div>
        </div>
        <div className={styles.faq}>
          <FAQ
            category={FAQCategory.PROFILE}
            actionSlot={
              <h4 className={clsx(styles.title, styles.faqTitle)}>
                Популярные вопросы
              </h4>
            }
          />
        </div>
      </div>
    </Drawer>
  )
}
